<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("create_stock_issue_voucher")}}</h4>
                <p class="text-subtitle-1">{{$t("used_to_issue_items_from_inventory")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <GoodIssueVoucherForm
                    ref="form"
                    v-model="data"
                    :warehouseId="warehouseId"
                    />
            </v-col>
        </v-row>
        <v-row class="my-2">
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    {{$t("save")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="onCancel">
                    {{$t("cancel_btn")}}
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import PAlert from '@/components/common/PAlert'
import GoodIssueVoucherForm from './../../components/warehouse/GoodIssueVoucherForm.vue';
import goodsIssueVoucherAPI from './../../services/stockJournal/goodsIssueVoucher';
import { v4 as uuid } from 'uuid';
export default {
    components: {
        GoodIssueVoucherForm,
        PAlert
    },
    data() {
        return {
            data: {},
            idempotentKey: null,
            loading: false,
            warehouseId: null,
            alert: {
                value: false,
                title: null,
                content: "Are you sure?",
                callback: null
            }
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, value: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            goodsIssueVoucherAPI.store({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({
                    name: "GoodsIssueVoucherDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            });
        },
        onCancel() {
            this.alert = {...this.alert, value: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel};
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.idempotentKey = uuid();
        this.warehouseId = this.$route.params.warehouseId;
    }
}
</script>

<style>

</style>